import styled from "styled-components";



const Container = styled.div `
  padding: 1vw 2vw;
  
  `
export const SectionContainer = styled.div `

padding: 7vw 10vw;

`

export default Container;